import { LOAD, UPDATE } from 'model/fspConfigValues';
import { takeLatest } from 'redux-saga/effects';
import { load, update } from 'sdk/fspConfigValues';
import { callAction, ORM } from '../util';
import {
  formatSuccessMessage,
  FSP_CONFIG_VALUES_LABEL,
  UPDATED,
} from '../consts';

const keyName = { key: 'configKey', name: FSP_CONFIG_VALUES_LABEL };

export default function* fspConfigValuesSaga() {
  yield takeLatest(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeLatest(
    UPDATE.ACTION,
    callAction({
      api: update,
      dataName: ORM,
      formatSuccessMessage: formatSuccessMessage(keyName, UPDATED),
      type: UPDATE,
    })
  );
}
